// GraphQL queries for Payments (proxy membership API)

export const listPaymentsQuery = `
  query ListPayments($input: ListPaymentsInput!) {
    listPayments(input: $input) {
      code
      paymentList {
        paymentId
        companyId
        subscriptionId
        paymentMethod
        paymentStatus
        amount
        currency
        transactionId
        phoneNumber
        countryCode
        cardLastFour
        cardBrand
        failureReason
        paidAt
        createdAt
        updatedAt
      }
    }
  }
`;

/** Super admin: list all payments with optional filters. */
export const listAllPaymentsSuperAdminQuery = `
  query ListAllPaymentsSuperAdmin($input: ListAllPaymentsSuperAdminInput) {
    listAllPaymentsSuperAdmin(input: $input) {
      code
      paymentList {
        paymentId
        companyId
        subscriptionId
        paymentMethod
        paymentStatus
        amount
        currency
        transactionId
        phoneNumber
        countryCode
        cardLastFour
        cardBrand
        failureReason
        paidAt
        createdAt
        updatedAt
      }
    }
  }
`;

export const getPaymentQuery = `
  query GetPayment($input: GetPaymentInput!) {
    getPayment(input: $input) {
      code
      payment {
        paymentId
        companyId
        subscriptionId
        paymentMethod
        paymentStatus
        amount
        currency
        transactionId
        phoneNumber
        countryCode
        cardLastFour
        cardBrand
        failureReason
        paidAt
        createdAt
        updatedAt
      }
    }
  }
`;
